import React from "react";

import { SuggestionList } from "../../SuggestionList/Desktop";

import { DropdownProps } from "../types";
import { DropdownWrapper } from "./styles";
import { Typography } from "../../Typography";

/**
 * Componente Dropdown (Desktop)
 *
 * Uma lista suspensa para sugestões, adaptada para versões desktop.
 *
 * @param {boolean} isVisible - Controla a visibilidade do dropdown.
 * @param {SuggestionListProps | { items: Airport[] }} suggestions - Sugestões exibidas na lista.
 * @param {(origin: Airport) => void} onSelect - Função executada ao selecionar um item.
 */
export const Dropdown: React.FC<DropdownProps> = ({
  suggestions,
  isVisible,
  isSearchTermTyped,
  onSelect,
}) => {
  if (!isVisible) return null;

  const renderSuggestions = () => {
    return (
      <SuggestionList
        {...suggestions}
        onSelect={onSelect}
        isSearchTermTyped={isSearchTermTyped}
      />
    );
  };

  return (
    <DropdownWrapper
      role="listbox"
      isVisible={isVisible}
      aria-hidden={!isVisible}
    >
      {renderSuggestions()}
    </DropdownWrapper>
  );
};
